// Error classes thrown from the search hook queryFns (useDateListSearch,
// useInspirations, useProductSearch). React Query receives these and the hook
// inspects their type to decide retry policy and which Kibana log to fire.
//
// - NonRetryableError: hard precondition failure (e.g. missing CID). Don't retry.
// - NetworkFetchError: fetch couldn't complete (network drop, abort, 5xx).
//   Worth retrying — the backend may not have answered at all.
// - EmptyResultsError: backend answered with zero results (or a 4xx). Retry
//   once at most — the backend gave a definitive answer.

export class NonRetryableError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "NonRetryableError";
  }
}

export class NetworkFetchError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "NetworkFetchError";
  }
}

export class EmptyResultsError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "EmptyResultsError";
  }
}

// Shared retry policy for search queries (datelist, inspirations, productsearch).
// Spread into the React Query options object: `...searchQueryRetryConfig`.
//
// - NonRetryableError: never retry (e.g. missing CID).
// - NetworkFetchError: up to 3 retries (transient — network drop, abort, 5xx).
// - Anything else (EmptyResultsError, HTTP 4xx): 1 retry max — backend gave a
//   definitive answer.
export const searchQueryRetryConfig = {
  retry: (failureCount: number, error: Error) => {
    if (error instanceof NonRetryableError) return false;
    if (error instanceof NetworkFetchError) return failureCount < 3;
    return failureCount < 1;
  },
  retryDelay: 100,
};
